/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    currencies: {
        menu: {
            index: 'Currencies',
            create: 'New',
            list: 'Currencies'
        },
        table_titles: {
            id: 'ID',
            name: 'Name',
            acronym: 'Acronym',
            symbol: 'Symbol',
            decimals: 'Decimals',
            matchmaking_threshold: 'Matchmaking Threshold',
            is_fiat: 'Type',
            setting: 'Edit / Delete',
        },
        edit: 'Edit a currency'
    }
}
